import {
  Button,
  DateRangePicker,
  DateRangePickerProps,
  DateValue,
} from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";
import { cn } from "@/utils";
import { isMobileSafari } from "react-device-detect";
import { t } from "@lingui/core/macro";
import { X } from "lucide-react";
import { isNativePlatform } from "@/utils/native";

type LimeDateRangePickerProps<T extends DateValue> = Omit<
  MantineFormValues,
  "onChange"
> &
  DateRangePickerProps<T> & {
    showClearButton?: boolean;
    isButtonOnlyMobile?: boolean;
  };

export const LimeDateRangePicker = React.forwardRef(
  <T extends DateValue>(
    {
      error,
      showClearButton,
      isButtonOnlyMobile,
      ...props
    }: LimeDateRangePickerProps<T>,
    ref: React.Ref<HTMLInputElement>,
  ) => (
    <DateRangePicker<T>
      ref={ref}
      errorMessage={error}
      isInvalid={!!error}
      showMonthAndYearPickers
      {...props}
      classNames={{
        ...props.classNames,
        input: cn(props.classNames?.input, {
          "text-[16px]": isMobileSafari || isNativePlatform(),
          "hidden md:flex": isButtonOnlyMobile,
        }),
        separator: cn(props.classNames?.separator, {
          "hidden md:flex": isButtonOnlyMobile,
        }),
      }}
      aria-label={
        (typeof props.label === "string" ? props.label : undefined) ??
        t`Razpon datuma`
      }
      startContent={
        showClearButton && props.value != null ? (
          <Button
            variant="light"
            size="sm"
            className="-ml-2 rounded-full"
            isIconOnly
            aria-label={t`Počisti datum`}
            isDisabled={props.isDisabled || props.isReadOnly}
            onPress={() => {
              props.onChange?.(null);
            }}
          >
            <X size={16} />
          </Button>
        ) : null
      }
    />
  ),
);

LimeDateRangePicker.displayName = "LimeDateRangePicker";
